import(/* webpackChunkName: "lotteryNumberInput" */ '../Styles/lotteryNumberInput.scss');

await import(/* webpackChunkName: "groupFormat" */ 'Common/Scripts/Common/groupFormat');

await import(/* webpackChunkName: "lotteryTicketFormat" */ 'Foundation/LotteryTicket/code/Scripts/LotteryTicket/lotteryTicketFormat');
await import(/* webpackChunkName: "requiredWhen" */ 'Foundation/Forms/code/Scripts/requiredWhen');
await import(/* webpackChunkName: "requiredAdvanced" */ 'Foundation/Forms/code/Scripts/requiredAdvanced');

await import(/* webpackChunkName: "sync" */ 'Feature/Common/code/Scripts/Common/sync');
await import(/* webpackChunkName: "forms" */ 'Feature/Forms/code/Scripts/forms');

import { html } from 'Common/Frontend/General/global-js/TemplateHandler';

const RedirectType = {
    None: 0,
    Won: 1,
    Lost: 2,
    NotParticipated: 3,
    Wronglot: 4
}

class Lottery {
    constructor(id, number, extra, expire) {
        this.id = id;
        this.lotteryNumber = number;
        this.extraNumber = extra;
        this.expire = expire;
    }
}

class LotteryNumberInput {
    constructor() {
        this.className = 'lottery-number-input';
        this.savedClassName = `${this.className}__saved`;
        this.profileClassName = `${this.className}__profile`;
        this.globalNotificationClassName = 'global-notification-container';

        this.lotteries = [];
    }

    setup() {
        if (document.querySelector(`.${this.className}--experience-editor`)) {
            return;
        }  

        document.querySelectorAll(`.${this.className}__form-container`).forEach(element => {
            const form = element.closest('form');
            if (form != null) {
                const input = form.querySelector('input[name="LotteryTicketNumber"]');
                input.addEventListener('focusout', function (inputValue) {
                    if (inputValue.target.value == "") {
                        input.closest('.form-field').classList.add('has-errors');
                        let inputErrorMessage = input.getAttribute('data-val-requiredadvanced');
                        let inputId = input.id + '-error';
                        let notificationContainer = input.closest('.form-field').querySelector('.notification-container');

                        if (notificationContainer) {
                            let notificationContainerSpan = notificationContainer.querySelector('span.field-validation-valid');
                            if (notificationContainerSpan) {
                                notificationContainerSpan.classList.remove('field-validation-valid');
                                notificationContainerSpan.classList.add('field-validation-error');
                                var tag = document.createElement("span");
                                tag.id = inputId;
                                var text = document.createTextNode(inputErrorMessage);
                                tag.appendChild(text);
                                notificationContainerSpan.appendChild(tag);
                            }
                        }
                    }
                })


                $(form).data('validator').settings.submitHandler = (form) => {
                    this.checkLotteryNumber(form);
                };
            }
        });

        this.getLocalStorage();
        this.initialValue();
    }

    render() {
        document.querySelectorAll(`.${this.savedClassName}-container`).forEach(parent => {
            if (this.lotteries.length > 0) {
                parent.hidden = false;
                parent.innerHTML = this.template(this.lotteries);
                parent.querySelectorAll(`.${this.savedClassName}`).forEach(element => {
                    element.querySelector(`.${this.savedClassName}__link`).onclick = this.checkSaveLotteryNumber;
                    element.querySelector(`.${this.savedClassName}__delete`).onclick = this.deleteLotteryNumber;
                });
            } else {
                parent.hidden = true;
            }
        });

        this.setupDesc();
        this.setupProfile();
    }

    setupProfile = () => {
        document.querySelectorAll(`.${this.profileClassName}-elements > div[class^="${this.className}"]`).forEach(element => {
            element.querySelector(`.${this.savedClassName}__link`).onclick = this.checkSaveLotteryNumber;
        });
    }

    checkSaveLotteryNumber = (event) => {
        const savedButton = event.currentTarget;
        const parent = savedButton.closest(`.${this.className}__saved`)
        const globalNotification = parent.closest(`.${this.className}`).querySelector(`.${this.globalNotificationClassName}`);

        savedButton.disabled = true;
        globalNotification.classList.remove('active');
        this.checkResults({ lotNumber: parent.dataset.lotNumber }).then((data) => {
            switch (data) {
                case RedirectType.Won:
                    this.redirectTo('won');
                    break;
                case RedirectType.Lost:
                    this.redirectTo('loss');
                    break;
                case RedirectType.NotParticipated:
                    this.redirectTo('notParticipate');
                    break;
                case RedirectType.Wronglot:
                    this.redirectTo('wrongNumber');
                    break;
                default:
                    savedButton.disabled = false;
                    globalNotification.classList.add('active');
                    console.error('Invalid redirect type')
            }
        }).catch((error) => {
            savedButton.disabled = false;
            globalNotification.classList.add('active');
        });
    }

    checkLotteryNumber = (form) => {
        const globalNotification = form.closest(`.${this.className}`).querySelector(`.${this.globalNotificationClassName}`);
        const checkbox = form.querySelector(`.${this.className}__form-checkbox input`);
        const textbox = form.querySelector(`.${this.className}__form-container input`);
        const button = form.querySelector(`.${this.className}__form-container button`);
        const lotNumber = textbox.value.replace(/ /g, '');

        button.disabled = true;
        globalNotification.classList.remove('active');
        this.checkResults({ lotNumber: lotNumber }).then((data) => {
            if (checkbox.checked && [RedirectType.Won, RedirectType.Lost, RedirectType.NotParticipated].includes(data)) {
                if (lotNumber.length == 9) {
                    lotNumber = '000' + lotNumber;
                }

                const lottery = new Lottery(Date.now(), lotNumber, 7, this.getDateByMonth(2));
                this.saveLotteryNumber(lottery);
            }

            if ([RedirectType.Won, RedirectType.Lost, RedirectType.NotParticipated, RedirectType.Wronglot].includes(data)) {
                textbox.value = '';
                checkbox.checked = false;
            }

            switch (data) {
                case RedirectType.Won:
                    this.redirectTo('won');
                    break;
                case RedirectType.Lost:
                    this.redirectTo('loss');
                    break;
                case RedirectType.NotParticipated:
                    this.redirectTo('notParticipate');
                    break;
                case RedirectType.Wronglot:
                    this.redirectTo('wrongNumber');
                    break;
                default:
                    button.disabled = false;
                    globalNotification.classList.add('active');
                    console.error('Invalid redirect type')
            }

        }).catch((error) => {
            button.disabled = false;
            globalNotification.classList.add('active');
        });
    }

    redirectTo = (dataset) => {
        const url = document.querySelector(`.${this.className}`).dataset[dataset];
        window.location.href = url;
    }

    deleteLotteryNumber = (event) => {
        const id = event.target.closest(`.${this.savedClassName}`).dataset.id;
        this.lotteries = this.lotteries.filter(x => x.id != id);
        this.setLocalStorage(this.lotteries);
        this.render();
    }

    saveLotteryNumber = (lottery) => {
        if (this.lotteries.length >= 5) {
            return;
        }

        if (this.lotteries.some(lot => lot.lotteryNumber === lottery.lotteryNumber)) {
            return;
        }

        this.lotteries.push(lottery);
        this.setLocalStorage(this.lotteries);
        this.render();
    }

    getLocalStorage = () => {
        const lotteryNumbers = localStorage.getItem('lotteryNumbers');
        if (lotteryNumbers) {
            let list = JSON.parse(lotteryNumbers);
            list = list.filter(item => new Date(item.expire) > new Date());

            this.lotteries = [...list];
            this.setLocalStorage(this.lotteries);
        }

        this.render();
    }

    setLocalStorage = (data) => {
        localStorage.setItem('lotteryNumbers', JSON.stringify(data));
    }

    getDateByMonth = (month) => {
        const currentDate = new Date();
        return new Date(currentDate.setMonth(currentDate.getMonth() + month)).toDateString();
    }

    initialValue = () => {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        const number = params.get('lotNumber');

        if (number) {
            if (!this.lotteries.some(lot => lot.lotteryNumber === number)) {
                document.querySelectorAll(`.${this.className}__form-container`).forEach(element => {
                    const textbox = element.querySelector('input');
                    textbox.value = number;
                });
            }
        }
    }

    setupDesc = () => {
        document.querySelectorAll(`.${this.className}`).forEach(parent => {
            const allDescriptions = parent.querySelectorAll(`.${this.className}__text`);
            const descriptions = [...allDescriptions].filter(x => !x.closest(`.${this.className}__profile`));

            if (descriptions.length > 1) {
                if (window.am.islogin) {
                    if (window.am.hasTickets) {
                        descriptions[0].hidden = true;
                        if (this.lotteries.length > 0) {
                            descriptions[1].hidden = false;
                            descriptions[2].hidden = true;
                        } else {
                            descriptions[1].hidden = true;
                            descriptions[2].hidden = false;
                        }
                        return;
                    }
                }

                descriptions[2].hidden = true;
                if (this.lotteries.length > 0) {
                    descriptions[0].hidden = true;
                    descriptions[1].hidden = false;
                } else {
                    descriptions[0].hidden = false;
                    descriptions[1].hidden = true;
                }
            }
        });
    }

    checkResults = async (data) => {
        const host = window.location.origin;
        const response = await fetch(host + '/api/sitecore/LotteryPayAndPlay/LotteryResults', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            const message = `An error has occured: ${response.status}`;
            throw new Error(message);
        }

        const json = await response.json();
        return json.responseText;
    }

    template = lotteries => html`
        ${lotteries.map(lottery => html`
            <div class='$${this.savedClassName}' data-id='$${lottery.id.toString()}' data-lot-number='${lottery.lotteryNumber.toString()}'>
                <div class='$${this.savedClassName}__lotnumber'>
                 ${[...lottery.lotteryNumber.toString()].map((number, index) => html`
                    <span class='$${(index + 1) >= lottery.extraNumber ? 'extra' : ''}'>$${number}</span>
                 `)}
                </div>
                <button class='$${this.savedClassName}__link small-button link-button'>
                    Dieses Los prüfen
                    <span class='icon icons-pfeil-bold'></span>
                </button>
                <div class='$${this.savedClassName}__delete'>
                    <span class='icon icons-loeschen'></span>
                    <button>Dieses Los entfernen</button>
                </div>
            </div>
        `)}
    `;
}

const lotteryNumberInput = new LotteryNumberInput();
lotteryNumberInput.setup(); 